import axios from 'axios';
import api_url from '../urls';
const actions = {

  async setProfessor (context, value) {
        context.commit('SET_PROFESSOR', value)
  },

  async allMateriasProfessor (context,value) {

    context.commit('PRELOADER_MUDAR',true)
     
    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
    
     await axios.get(api_url.api_admin + 'v1/admin/allMateriasProfessor/'+ value,
      {
         headers: {
             'authorization': AuthStr,
             'Accept' : 'application/json',
             'Content-Type': 'application/json'
         }
     })
     .then(response => {
          console.log(response.data);
        context.commit('ALL_MATERIAS_PROFESSOR', response.data)
     })
     .catch((error) => {
         console.log(error.response.data.message);
       }).finally(()=> context.commit('PRELOADER_MUDAR',false))
     
 },
}

export default actions